import { FC, ReactElement } from 'react';

type Props = {
  children: ReactElement;
};

const AltLayout: FC<Props> = (props) => <div id="main">{props.children}</div>;

export default AltLayout;
